import { EFFORT_SELECT_VALUES, normalizeEffortValue } from '../../constants/effort';

interface EffortSelectFieldProps {
  value: number;
  maxValue?: number;
  onChange: (value: number) => void;
  size?: 'small' | 'medium';
}

function EffortSelectField({ value, maxValue = EFFORT_SELECT_VALUES[EFFORT_SELECT_VALUES.length - 1], onChange, size = 'small' }: EffortSelectFieldProps) {
  const normalizedValue = normalizeEffortValue(value);
  const allowedMaxValue = Math.max(0, normalizeEffortValue(maxValue));

  const sizeClass =
    size === 'small'
      ? 'h-7 px-2 text-[0.8rem]'
      : 'h-8 px-2.5 text-[0.9rem]';

  return (
    <div className={`relative inline-block ${size === 'small' ? 'min-w-[60px]' : 'min-w-[72px]'}`}>
      <select
        value={normalizedValue}
        onChange={(e) => onChange(Number(e.target.value))}
        className={`block w-full rounded border border-gray-300 bg-white text-center shadow-sm focus:border-sky-500 focus:ring-2 focus:ring-sky-200 focus:outline-none ${sizeClass}`}
      >
        {EFFORT_SELECT_VALUES.map((option) => (
          <option key={option} value={option} disabled={option > allowedMaxValue}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default EffortSelectField;
